<template>
  <b-modal
    id="admin-carts-modal"
    :title="trans('admin_carts')"
    size="lg"
    body-class="p-0"
    hide-footer
    @shown="fetch"
  >
    <div class="p-3">
      {{ trans('admin_carts_about') }}
    </div>
    <b-row class="p-3">
      <b-col>
        <b-button
          variant="outline-primary"
          size="sm"
          :disabled="busy"
          v-b-modal.admin-create-cart-modal
        >
          <i class="fa fa-fw fa-plus"></i>
          {{ trans('shopping_cart') }}
        </b-button>
      </b-col>
      <b-col class="col-auto">
        <b-button variant="outline-secondary" size="sm" class="px-2" @click="fetch" :disabled="busy">
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-overlay :show="busy">
      <b-table
        ref="table"
        class="bg-white"
        :items="items"
        :fields="fields"
        small
        responsive
        show-empty
      >
        <template v-slot:empty>
          <p class="lead text-center text-muted p-3">{{ trans('none') }}</p>
        </template>
        <template v-slot:head(active)="data">
          <span class="ml-2">{{ data.label }}</span>
        </template>
        <template v-slot:cell(active)="data">
          <i v-if="data.value" :class="`fa fa-fw fa-shopping-cart ml-2 text-success ${moment().isAfter(data.item.expired_at) ? 'text-danger' : 'text-success'}`"></i>
          <b-link
            v-if="!data.value"
            size="sm"
            class="text-muted ml-2"
            :title="trans('switch')"
            :disabled="busy"
            :href="`${iframeUrlPrefix}/org/${organization.id}/cart/change/${data.item.ucid}`"
          >
            <i class="fa fa-fw fa-exchange-alt"></i>
          </b-link>
        </template>
        <template v-slot:cell(expired_at)="data">
          <span :class="moment().isAfter(data.value) ? 'text-danger' : 'text-success'" :title="moment(data.value).format('LLL')">
            {{ moment(data.value).fromNow() }}
          </span>
        </template>
        <template v-slot:cell(created_at)="data">
          <span>
            {{ moment(data.value).format('LLL') }}
          </span>
        </template>
        <template v-slot:cell(action)="data">
          <b-button
            v-if="!data.item.active"
            variant="link"
            size="sm"
            class="text-danger"
            :title="trans('empty_the_cart')"
            :disabled="busy"
            @click="onDeleteCart(data.item)"
          >
            <i class="fa fa-fw fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-overlay>

    <admin-create-cart-modal
      :organization="organization"
      @create="onCartCreated"
    ></admin-create-cart-modal>
  </b-modal>
</template>

<script>
  import AdminCreateCartModal from './AdminCreateCartModal'

  export default {
    props: {
      organization: Object,
      invoice: Object, // active cart
    },
    components: {
      AdminCreateCartModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
        invoices: null,
        fields: [
          {key: 'active', label: trans('active')},
          {key: 'expired_at', label: trans('expires')},
          {key: 'top_invoice_item_count', label: trans('items')},
          {
            key: 'recipient',
            label: trans('client'),
            formatter(value, key, item) {
              return item.recipient ? item.recipient.name : null
            },
          },
          {
            key: 'admin',
            label: trans('administrator'),
            formatter(value, key, item) {
              return item.admin ? item.admin.name : null
            },
          },
          {key: 'created_at', label: trans('created')},
          {key: 'action', label: ''},
        ],
      }
    },
    computed: {
      items() {
        return _.map(this.invoices || [], invoice => {
          invoice.active = !!this.invoice && invoice.ucid == this.invoice.ucid
          return invoice
        })
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        axios.get(`/org/${this.organization.id}/cart/list`)
        .then(response => {
          this.busy = false
          this.invoices = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      onDeleteCart(invoice) {
        this.$bvModal.msgBoxConfirm(trans('are_you_sure'), {
          title: trans('empty_the_cart'),
          okTitle: trans('yes'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          this.busy = true
          this.error = null
          axios.delete(`/org/${this.organization.id}/cart/destroy/${invoice.ucid}`)
          .then(response => {
            this.busy = false
            this.fetch()
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        })
      },
      onCartCreated() {
        window.location = `/org/${this.organization.id}`
      },
    },
    mounted() {
      window.adminCartsModal = this
    },
  }
</script>